import { render, staticRenderFns } from "./BookingRequest.vue?vue&type=template&id=8036f8da&"
import script from "./BookingRequest.vue?vue&type=script&lang=ts&"
export * from "./BookingRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports